// Runtime configuration for the source-less deploy.
//
// `window._env_` is generated at container start by `Docker/30-generate-env-js.sh` from the host
// `.env`, so the built image is config-agnostic — one image, deployed to any environment/host. The
// static `process.env.REACT_APP_*` references below are inlined by CRA at build time and serve ONLY
// as the local-dev fallback: during `yarn start`, `public/env.js` sets an empty `window._env_`, so
// the baked `process.env` values win. In a deployed container the entrypoint overwrites `env.js`
// with the real values and `window._env_` wins.
//
// Add a new var in exactly two places: here (a field reading `window._env_` with a static
// `process.env.REACT_APP_*` fallback) and in `.env.example`. The entrypoint emits every
// `REACT_APP_*` automatically — no third edit.

declare global {
  interface Window {
    _env_?: Record<string, string | undefined>
  }
}

const runtime: Record<string, string | undefined> =
  (typeof window !== 'undefined' && window._env_) || {}

export const ENV = {
  GRAPH_BFF:
    runtime.REACT_APP_GRAPH_BFF ?? process.env.REACT_APP_GRAPH_BFF ?? '',
  GRAPH_BFF_WS:
    runtime.REACT_APP_GRAPH_BFF_WS ?? process.env.REACT_APP_GRAPH_BFF_WS ?? '',
  BASE_URL: runtime.REACT_APP_BASE_URL ?? process.env.REACT_APP_BASE_URL ?? '',
  IDLE_WARNING_MINUTES:
    runtime.REACT_APP_IDLE_WARNING_MINUTES ??
    process.env.REACT_APP_IDLE_WARNING_MINUTES ??
    '',
  ENVIRONMENT:
    runtime.REACT_APP_ENVIRONMENT ?? process.env.REACT_APP_ENVIRONMENT ?? ''
} as const
